import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useEffect, useRef, useState } from "react";
import { trackEvent } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../utils/mixpanelEvents";
import Toast from "../../Toast";
import { t } from "i18next";
import useBinaryService from "./binaryService";
import { decodeBase64Content, fetchS3Content } from "./s3ContentService";
export var useSelectedImage = function useSelectedImage(workspaceId, patientId) {
  var _useState = useState(null),
    selectedImage = _useState[0],
    setSelectedImage = _useState[1];
  var _useState2 = useState(false),
    isLoadingImage = _useState2[0],
    setIsLoadingImage = _useState2[1];
  var binaryService = useBinaryService(workspaceId, patientId);
  var blobUrlsRef = useRef([]);
  useEffect(function () {
    return function () {
      blobUrlsRef.current.forEach(function (url) {
        if (url.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, []);
  var handleImageClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(image, encounter, documentReference, sourceType, sourceData) {
      var binary, resourceType, resourceId, _iterator, _step, _serviceRequest$diagn, serviceRequest, payload, base64Data, contentType, blobUrl, htmlContent, response, _yield$fetchS3Content, _decodeBase64Content, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            trackEvent(MIXPANEL_EVENTS.ENCOUNTER_DETAIL_OPENED, {
              label: image.name
            });
            // Determine which resource to use based on sourceType or fallback to document_reference
            binary = null;
            resourceType = "";
            resourceId = "";
            if (!(sourceType === "diagnostic_report" && sourceData !== null && sourceData !== void 0 && sourceData.binary)) {
              _context.n = 1;
              break;
            }
            binary = sourceData.binary;
            resourceType = sourceData.resource_type;
            resourceId = sourceData.fhir_id;
            _context.n = 10;
            break;
          case 1:
            if (!(sourceType === "document_reference" && sourceData !== null && sourceData !== void 0 && sourceData.binary)) {
              _context.n = 2;
              break;
            }
            binary = sourceData.binary;
            resourceType = sourceData.resource_type;
            resourceId = sourceData.fhir_id;
            _context.n = 10;
            break;
          case 2:
            if (!(documentReference !== null && documentReference !== void 0 && documentReference.binary)) {
              _context.n = 3;
              break;
            }
            // Fallback to document_reference
            binary = documentReference.binary;
            resourceType = documentReference.resource_type;
            resourceId = documentReference.fhir_id;
            _context.n = 10;
            break;
          case 3:
            if (!(encounter.service_requests && Array.isArray(encounter.service_requests))) {
              _context.n = 10;
              break;
            }
            // Fallback to diagnostic_report in service_requests
            _iterator = _createForOfIteratorHelper(encounter.service_requests);
            _context.p = 4;
            _iterator.s();
          case 5:
            if ((_step = _iterator.n()).done) {
              _context.n = 7;
              break;
            }
            serviceRequest = _step.value;
            if (!((_serviceRequest$diagn = serviceRequest.diagnostic_report) !== null && _serviceRequest$diagn !== void 0 && _serviceRequest$diagn.binary)) {
              _context.n = 6;
              break;
            }
            binary = serviceRequest.diagnostic_report.binary;
            resourceType = serviceRequest.diagnostic_report.resource_type;
            resourceId = serviceRequest.diagnostic_report.fhir_id;
            return _context.a(3, 7);
          case 6:
            _context.n = 5;
            break;
          case 7:
            _context.n = 9;
            break;
          case 8:
            _context.p = 8;
            _t = _context.v;
            _iterator.e(_t);
          case 9:
            _context.p = 9;
            _iterator.f();
            return _context.f(9);
          case 10:
            if (binary) {
              _context.n = 11;
              break;
            }
            Toast.error(t("message.no_binary_data_available"));
            return _context.a(2);
          case 11:
            // Build the payload
            payload = {
              fhir_id: binary.fhir_id,
              content_type: binary.content_type,
              resource_type: resourceType,
              resource_id: resourceId
            };
            setIsLoadingImage(true);
            _context.p = 12;
            base64Data = null;
            contentType = "";
            blobUrl = "";
            if (!binary.data) {
              _context.n = 13;
              break;
            }
            base64Data = binary.data;
            contentType = binary.content_type;
            _context.n = 17;
            break;
          case 13:
            _context.n = 14;
            return binaryService.mutateAsync(payload);
          case 14:
            response = _context.v;
            contentType = response.content_type;
            if (response.url) {
              _context.n = 15;
              break;
            }
            throw new Error(t("message.failed_to_load_image"));
          case 15:
            _context.n = 16;
            return fetchS3Content(response.url, contentType);
          case 16:
            _yield$fetchS3Content = _context.v;
            htmlContent = _yield$fetchS3Content.htmlContent;
            blobUrl = _yield$fetchS3Content.blobUrl;
            if (blobUrl) blobUrlsRef.current.push(blobUrl);
          case 17:
            if (base64Data !== null) {
              _decodeBase64Content = decodeBase64Content(base64Data, contentType);
              htmlContent = _decodeBase64Content.htmlContent;
              blobUrl = _decodeBase64Content.blobUrl;
              if (blobUrl) blobUrlsRef.current.push(blobUrl);
            }

            // Set the selected image to open the modal
            setSelectedImage({
              name: image.name,
              url: blobUrl,
              encounter: encounter,
              contentType: contentType,
              htmlContent: htmlContent
            });
            _context.n = 19;
            break;
          case 18:
            _context.p = 18;
            _t2 = _context.v;
            console.error("Error fetching binary data:", _t2);
            Toast.error(t("message.failed_to_load_image"));
          case 19:
            _context.p = 19;
            setIsLoadingImage(false);
            return _context.f(19);
          case 20:
            return _context.a(2);
        }
      }, _callee, null, [[12, 18, 19, 20], [4, 8, 9, 10]]);
    }));
    return function handleImageClick(_x, _x2, _x3, _x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    selectedImage: selectedImage,
    setSelectedImage: setSelectedImage,
    isLoadingImage: isLoadingImage,
    handleImageClick: handleImageClick
  };
};